module.exports = __webpack_public_path__ + "media/gastric varices.45499310.wav";